// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"1677d72e","28":"bd15f8a2","209":"c428252a","307":"5ee9fb65","400":"da8aa195","453":"661f9796","455":"75cdf2d3","596":"0a2ed086","726":"24502539","977":"bfbf128b"}[chunkId] + ".chunk.js";
};